/* ==========================================================================
   Collection page — filters, sorting and pagination without page reloads
   Adapter of the shared filter bar (assets/filter-bar.js, loaded right
   before this file): the bar, the mobile sheet and swapping the results live
   there. Here, what is the collection's own: filters are product tags in the
   URL path, /collections/<handle>/<tag>+<tag>, one option per group (Shopify
   combines tags with AND), the groups come from #CollectionFiltersConfig
   (snippets/filter-groups.liquid), and the options that would give no
   results are found with light requests to
   sections/collection-filter-tags.liquid.
   Loaded only from sections/collection-template.liquid.
   ========================================================================== */
(function () {
  'use strict';

  // Already running (e.g. the theme editor inserted the section's script again):
  // the first copy re-initializes itself on shopify:section:load
  if (window.CollectionFilters || !window.FilterBar) return;

  var TAGS_SECTION_ID = 'collection-filter-tags'; // tags only, for the dimmed options
  var readJSON = window.FilterBar.readJSON;

  // Tags are read from what follows /collections/<handle>/ in the path, not by
  // counting segments, so a locale prefix (/en/...) or a trailing slash works.
  // Decoded so "ni%C3%B1o" matches the "niño" option.
  function tagsFromPath(pathname) {
    var match = pathname.match(/\/collections\/[^\/]+\/([^\/]+)/);
    if (!match) return [];
    return match[1].split('+').map(function (tag) {
      try {
        tag = decodeURIComponent(tag);
      } catch (e) {}
      return tag.toLowerCase();
    });
  }

  function stateFromPath(ctx, pathname) {
    var tags = tagsFromPath(pathname);
    var next = {};
    ctx.groups.forEach(function (filter) {
      filter.options.forEach(function (option) {
        if (option.val && tags.indexOf(option.val.toLowerCase()) > -1) {
          next[filter.name] = option.val;
        }
      });
    });
    return next;
  }

  // Collection path with the tags of a selection: /collections/<handle>/<tag>+<tag>
  function collectionPath(ctx, selection) {
    var tags = [];
    ctx.groups.forEach(function (filter) {
      if (selection[filter.name]) tags.push(encodeURIComponent(selection[filter.name]));
    });
    return ctx.data.url + (tags.length ? '/' + tags.join('+') : '');
  }

  // Collection URL with the checked tags. Keeps the query string (sort_by…)
  // but drops the page: a new filter or sort order starts on page 1.
  function filteredUrl(ctx, selection, sortBy) {
    var params = new URLSearchParams(location.search);
    params.delete('page');
    if (sortBy) params.set('sort_by', sortBy);
    var query = params.toString();
    return collectionPath(ctx, selection) + (query ? '?' + query : '');
  }

  // Picking another option in a group that already has one replaces its tag,
  // so the current results can't tell whether it gives products. For each such
  // group, ask for the tags of the results with only the other groups' filters
  // (light request, sections/collection-filter-tags.liquid): an option gives
  // products if its tag is there. One request per group, all in parallel.
  // A failed one resolves to nothing, which leaves that group's options enabled.
  function loadGroupTags(ctx, selection, signal) {
    var groups = ctx.groups.filter(function (filter) {
      return selection[filter.name];
    });
    return Promise.all(groups.map(function (filter) {
      var others = Object.assign({}, selection);
      delete others[filter.name];
      return fetch(collectionPath(ctx, others) + '?section_id=' + TAGS_SECTION_ID, { signal: signal, credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var tags = readJSON(doc, 'CollectionFilterTags');
          if (!tags) throw new Error('No tags in the response');
          return tags;
        })
        .catch(function () {
          return null;
        });
    })).then(function (lists) {
      var result = {};
      groups.forEach(function (filter, i) {
        if (lists[i]) result[filter.name] = lists[i];
      });
      return result;
    });
  }

  // Handle of a collection URL: /collections/<handle>…
  function collectionHandle(url) {
    var match = url.match(/\/collections\/([^\/?#]+)/);
    return match ? match[1] : '';
  }

  var bar = window.FilterBar({
    root: '[data-section="CollectionTemplate"]',
    sectionId: 'collection-template',
    prefix: 'CollectionFilter',
    sortId: 'SortBy',
    dataId: 'CollectionFiltersData', // url, count, sort and the tags of the results
    metaId: 'CollectionPageMeta',
    historyKey: 'collectionFilters',
    // The results wait for the tags, so the options are never wrong
    blocking: true,

    groups: function (ctx) {
      return readJSON(ctx.root, 'CollectionFiltersConfig');
    },

    readState: function (ctx) {
      return stateFromPath(ctx, location.pathname);
    },

    url: function (ctx, selection, sortBy) {
      return filteredUrl(ctx, selection, sortBy);
    },

    // "Tipo de producto": the current collection is marked
    isCurrentLink: function (ctx, option) {
      return collectionHandle(option.href) === collectionHandle(ctx.data.url);
    },

    // Groups without a checked option: the tag must be in the current
    // results. Groups with one: in the results with only the other groups'
    // filters (loadGroupTags).
    availabilityKey: function (ctx, selection) {
      return collectionPath(ctx, selection);
    },
    loadAvailability: loadGroupTags,
    loadOnInit: function (ctx, selection) {
      return Object.keys(selection).length > 0;
    },
    isEmpty: function (ctx, group, value) {
      var tags = ctx.state[group] ? ctx.avail[group] : ctx.data.tags;
      return !!tags && tags.indexOf(value.toLowerCase()) === -1;
    }
  });

  window.CollectionFilters = { sortBy: bar.sortBy };
})();
